// getters
const controlaccesopermiss = state => state.controlaccesopermiss

export default {
  controlaccesopermiss
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/permiss/getters.js